var _g, _g2, _g3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProcessOrders(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 91,
    viewBox: "0 0 108 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    filter: "url(#filter0_f_8264_81641)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 28.5C32 20.768 38.268 14.5 46 14.5H62C69.732 14.5 76 20.768 76 28.5V44.5C76 52.232 69.732 58.5 62 58.5H46C38.268 58.5 32 52.232 32 44.5V28.5Z",
    fill: "url(#paint0_linear_8264_81641)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_dd_8264_81641)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 28.5C32 20.768 38.268 14.5 46 14.5H62C69.732 14.5 76 20.768 76 28.5V44.5C76 52.232 69.732 58.5 62 58.5H46C38.268 58.5 32 52.232 32 44.5V28.5Z",
    fill: "url(#paint1_linear_8264_81641)",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.3004 28.8011C46.0345 29.0671 46.0345 29.4954 46.3004 29.7614C46.5664 30.0273 46.9947 30.0273 47.2606 29.7614C49.0602 27.9618 51.4503 26.974 53.9959 26.9705C56.5415 26.974 58.9317 27.9618 60.7312 29.7614C62.5066 31.5367 63.491 33.8889 63.5186 36.3965L62.175 35.0529C61.909 34.7869 61.4807 34.7869 61.2148 35.0529C60.9488 35.3188 60.9488 35.7471 61.2148 36.0131L64.1023 38.9006L66.9899 36.0131C67.2558 35.7471 67.2558 35.3188 66.9899 35.0529C66.7239 34.7869 66.2956 34.7869 66.0297 35.0529L64.8795 36.2031C64.8035 33.4053 63.6844 30.7872 61.6983 28.8011C59.6432 26.746 56.9077 25.6131 53.9994 25.6131C51.0911 25.6131 48.3555 26.746 46.3004 28.8011Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.7,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.9976 47.3851C56.9058 47.3851 59.638 46.2556 61.6931 44.2005C61.9591 43.9345 61.9591 43.5063 61.6931 43.2403C61.4271 42.9743 60.9954 42.9709 60.7294 43.2368C58.9299 45.0364 56.5397 46.0242 53.9976 46.0242C51.4485 46.0242 49.0584 45.0364 47.2588 43.2368C45.4835 41.4615 44.4991 39.1093 44.4714 36.6017L45.8151 37.9453C46.081 38.2113 46.5093 38.2113 46.7753 37.9453C47.0412 37.6794 47.0412 37.2511 46.7753 36.9851L43.8912 34.101L41.0071 36.9851C40.7411 37.2511 40.7411 37.6794 41.0071 37.9453C41.273 38.2113 41.7013 38.2113 41.9673 37.9453L43.1175 36.7951C43.1935 39.5929 44.3126 42.211 46.2986 44.1971C48.3537 46.2522 51.0893 47.3851 53.9976 47.3851Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.7,
    strokeLinejoin: "round"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_dd_8264_81641)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-1_8264_81641",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66 18.5C66 15.1863 68.6863 12.5 72 12.5C75.3137 12.5 78 15.1863 78 18.5C78 21.8137 75.3137 24.5 72 24.5C68.6863 24.5 66 21.8137 66 18.5Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M66 18.5C66 15.1863 68.6863 12.5 72 12.5C75.3137 12.5 78 15.1863 78 18.5C78 21.8137 75.3137 24.5 72 24.5C68.6863 24.5 66 21.8137 66 18.5Z",
    fill: "url(#paint2_linear_8264_81641)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66 18.5M78 18.5M78 18.5M66 18.5M72 12.5M78 18.5M72 24.5M66 18.5M72 24.5V22.5C69.7909 22.5 68 20.7091 68 18.5H66H64C64 22.9183 67.5817 26.5 72 26.5V24.5ZM78 18.5H76C76 20.7091 74.2091 22.5 72 22.5V24.5V26.5C76.4183 26.5 80 22.9183 80 18.5H78ZM72 12.5V14.5C74.2091 14.5 76 16.2909 76 18.5H78H80C80 14.0817 76.4183 10.5 72 10.5V12.5ZM72 12.5V10.5C67.5817 10.5 64 14.0817 64 18.5H66H68C68 16.2909 69.7909 14.5 72 14.5V12.5Z",
    fill: "white",
    mask: "url(#path-5-inside-1_8264_81641)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_8264_81641",
    x: 0,
    y: -17.5,
    width: 108,
    height: 108,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16,
    result: "effect1_foregroundBlur_8264_81641"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_dd_8264_81641",
    x: 20,
    y: 12.5,
    width: 68,
    height: 68,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_8264_81641"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8264_81641"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 3,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_8264_81641"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_8264_81641",
    result: "effect2_dropShadow_8264_81641"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_8264_81641",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_dd_8264_81641",
    x: 54,
    y: 10.5,
    width: 36,
    height: 36,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_8264_81641"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8264_81641"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 3,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_8264_81641"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_8264_81641",
    result: "effect2_dropShadow_8264_81641"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_8264_81641",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8264_81641",
    x1: 32,
    y1: 14.5,
    x2: 76,
    y2: 58.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0B100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E17100"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8264_81641",
    x1: 32,
    y1: 14.5,
    x2: 76,
    y2: 58.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0B100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E17100"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8264_81641",
    x1: 66,
    y1: 12.5,
    x2: 78,
    y2: 24.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0B100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E17100"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcessOrders);
export default __webpack_public_path__ + "static/media/Process Orders.1d72f9ecdcdba7aba955f229dfa69f4b.svg";
export { ForwardRef as ReactComponent };